<template>
  <DefaultLayout>
    <Container>
      <h1>User</h1>
      <pre class="border-3 tw-my-5 tw-rounded tw-border-r-4 tw-bg-gp-charcoal-grey tw-p-4">{{
        user
      }}</pre>
      <h1>Roles</h1>
      <ul class="tw-my-5">
        <li :key="role" v-for="role in roles">{{ role }}</li>
      </ul>
      <h1>Access Token</h1>

      <GpTextInput :model-value="token" class="tw-my-5" input-id="token" readonly>
        <template #actions>
          <GpInputBtn @click="copyToken" :icon="faClipboard" />
        </template>
      </GpTextInput>

      <pre class="border-3 tw-my-5 tw-rounded tw-border-r-4 tw-bg-gp-charcoal-grey tw-p-4">{{
        parsedToken
      }}</pre>
    </Container>
  </DefaultLayout>
</template>

<script lang="ts">
import { GpInputBtn, GpTextInput } from '@gportal/uikit';
import DefaultLayout from '@panel/layouts/Layout.vue';
import { computed, defineComponent } from 'vue';
import { useSessionStore } from 'gpcore-apikit/store/pinia/session';
import Container from 'gpcore-uikit/components/Component.Container.vue';
import { useClipboard } from '@vueuse/core';
import { faClipboard } from '@fortawesome/pro-solid-svg-icons';
import useNotifications from 'gpcore-uikit/composables/useNotifications';
import useViewTitle from '@panel/composables/useViewTitle';

export default defineComponent({
  components: {
    DefaultLayout,
    GpTextInput,
    GpInputBtn,
    Container,
  },
  setup() {
    useViewTitle('Debug');
    const sessionStore = useSessionStore();
    const { addNotification } = useNotifications();
    const { copy } = useClipboard();

    const token = computed(() => sessionStore.token);
    const parsedToken = computed(() => sessionStore.mainSession.parsedToken);
    const roles = computed(() => sessionStore.roles);
    const user = computed(() => JSON.stringify(sessionStore.session.user, null, 2));

    const copyToken = () => {
      copy(token.value);
      addNotification({
        message: 'Token has been copied to clipboard.',
        type: 'success',
      });
    };

    return {
      copyToken,
      faClipboard,
      token,
      parsedToken,
      roles,
      user,
    };
  },
});
</script>
